import { CancelTokenSource } from 'axios';
import axios from 'services/http';
import { TaxPointDto } from 'ts-types/api.types';

const { REACT_APP_API_BASE_URL: baseUrl } = process.env;
const apiUri = `${baseUrl}/api/tax-points`;

export const getAllTaxPointsForTariffTaxPoint = (tariffTaxPointId: number, source: CancelTokenSource) : Promise<Array<TaxPointDto>> => {
  return axios
      .get(`${apiUri}/by-tariff-tax-point/${tariffTaxPointId}`, {cancelToken: source.token})
      .then(response => response.data);
};
